export { default } from './Seo'
